/**
 * WordPress dependencies
 */
import { applyFilters } from '@wordpress/hooks';

const BlockLayouts = ( { layouts, label = 'Layouts', value, onChange, blockName } ) => {
	layouts = applyFilters( `gutenify--${ blockName }--layouts`, layouts );
	return <>{ layouts && <div className="gutenify-template-browser">
		<h2>{ label }</h2>

		<ul>
			{ layouts.map( ( layout ) => {
				let classnames = 'gutenify-template-browser-item';
				if ( value === layout.name ) {
					classnames += ' gutenify-template-browser-item-active';
				}
				return <li className={ classnames } key={ layout.name }>
					<button className={ `gutenify-template-browser-selector` } onClick={ () => {
						onChange( layout );
					} }>
						<img src={ layout?.thumbnailUrl ? layout.thumbnailUrl : `${ window.gutenify_block_data.plugin_directory_url }/assets/images/layouts/${ blockName }/${ layout.name }.png` } alt={ layout.name } />
						<small>{ layout.label }</small>
					</button></li>;
			} ) }
		</ul>
	</div> }</>;
};

export default BlockLayouts;
